import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText,
  Alert,
} from 'reactstrap';
import { CardHeaderWithToolbars, Title } from '../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars';
import FiltersPanel from './Filters';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import { DEFAULT_PER_PAGE } from '../../constants/settings';
import { getKickPointRedemptionList } from '../../actions/kickPointRedemptionAction';
import privateView from '../../components/hocs/privateView';
import List from './kickPointRedemptionIndex/List';
import { Th } from '../../components/Tbl';
import Analytics from '../../services/Analytics';

const defaultParams = {
  per_page: DEFAULT_PER_PAGE
}

const DEFAULT_ROUTE = '/kick_point_redemptions';

class KickPointRedemptionIndex extends Component {
  constructor() {
    super();
    this.state = {
      _filterOpen: false,
      _params: {
        ...defaultParams
      },
      _isResetFilter: false,
      _list: [],
      _pagination: {},
      _isFetchData: false,
      _errorMsg: null,
    }
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._refreshList = this._refreshList.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
  }

  componentDidMount() {
    const { email } = this.props.injectedProps;
    this._refreshList();
    Analytics.recordPageView('kick_point_redemption_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { kickPointRedemption } = this.props;
    const prev = prevProps.kickPointRedemption;
    if (prevState._isFetchData && prev.isFetch !== kickPointRedemption.isFetch && prev.isFetch) {
      if (prev.error === null) {
        const { data, ...pagination } = kickPointRedemption.list;
        this.setState({
          _list: data || [],
          _pagination: pagination,
          _isFetchData: false,
          _errorMsg: null
        })
      } else {
        // The error lands before isFetch flips to false, so without this branch
        // _isFetchData would never reset and the table would stay on "Loading...".
        const { message } = prev.error;
        this.setState({
          _isFetchData: false,
          _errorMsg: message || "We've got something errors. Please refresh the list."
        })
      }
    }
  }

  _getList(rawParams = {}) {
    let params = {};
    Object.keys(rawParams)
      .filter(key => rawParams[key] != '')
      .forEach(key => params[key] = rawParams[key]);
    this.props.getList({ params });
  }

  _handleGoto(page) {
    const _params = this.state._params;
    _params.page = page;
    this.setState({
      _params,
      _isFetchData: true
    }, () => this._getList(this.state._params));
  }

  _handleRefresh(e) {
    e.preventDefault();
    this._refreshList();
  }

  _handleApplyFilter(payloadFilter) {
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        page: 1,
      },
      _isFetchData: true
    }, () => this._getList(this.state._params));
  }

  _refreshList() {
    const { page, ..._params } = this.state._params;
    this.setState({
      _params: { ..._params },
      _isFetchData: true
    }, () => this._getList(this.state._params));
  }

  _handleResetFilter(e) {
    e.preventDefault();
    this.setState({
      _params: {
        ...defaultParams
      },
      _isResetFilter: true,
      _isFetchData: true,
    }, () => this._getList(this.state._params));
  }

  _toggleFilterPanel() {
    this.setState({ _filterOpen: !this.state._filterOpen })
  }

  _handleToggleFilterPanel(e) {
    e.preventDefault();
    this._toggleFilterPanel();
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Kick Point Redemption List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FiltersPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={() => this.setState({ _isResetFilter: false, _filterOpen: false })}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section will display kick point redemptions.
                </CardText>
                {this.state._errorMsg ? (
                  <Alert color="danger" isOpen toggle={() => this.setState({ _errorMsg: null })}>
                    <strong>Oh Snap!</strong> {this.state._errorMsg}
                  </Alert>
                ) : null}
                <List
                  data={this.state._list}
                  isLoading={this.state._isFetchData}
                  from={this.state._pagination.from}
                  to={this.state._pagination.to}
                  perPage={this.state._pagination.per_page}
                  currentPage={this.state._pagination.current_page}
                  lastPage={this.state._pagination.last_page}
                  total={this.state._pagination.total}
                  statusCode={this.state._pagination.status_code}
                  defaultRoute={DEFAULT_ROUTE}
                  onRenderHeader={() => (
                    <tr>
                      <Th>No.</Th>
                      <Th>Product Variant</Th>
                      <Th>Active</Th>
                      <Th>Period</Th>
                      <Th>Updated</Th>
                      <Th>Action</Th>
                    </tr>
                  )}
                  onGotoPageList={this._handleGoto}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = ({ kickPointRedemption, auth: { isFetch, roles, isLogged, id, email } }) => {
  return {
    kickPointRedemption,
    email,
    guardData: { isFetch, roles, isLogged, id, email }
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (query) => dispatch(getKickPointRedemptionList(query)),
  }
};

const enhance = connect(mapStateToProps, mapDispatchToProps);
export default enhance(privateView(KickPointRedemptionIndex, ['superadministrator', 'administrator']));
